/* @ngInject */
export default function NvTeamCard(
  RailsRoutes,
  $state,
) {
  return {
    scope: {
      team: '=',
      course: '=',
    },
    controller: function ctrl($scope) {
'ngInject';
      const vm = this;
      vm.RailsRoutes = RailsRoutes;
      vm.$state = $state;
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'learner_profiles/templates/nv-team-card.html',
  };
}
